// extracted by mini-css-extract-plugin
module.exports = {"button":"HamburgerButton_button__doSQl","menuIcon":"HamburgerButton_menuIcon__s_6KJ"};